/**
 * dd-group-duration-second.js — 组团游「按时长展示」二级页交互
 *
 * 职责（轻量，无依赖，失效静默）：
 *   1. 滚动监听（scrollspy）：用 IntersectionObserver 高亮当前所在的时长档步骤
 *   2. 锚点平滑滚动：点击时间轴步骤或 Hero 按钮平滑滚动到对应分组，并补上吸顶头部的偏移
 *
 * 注意：时长导航条刻意不做 position:sticky —— Dawn 头部本身吸顶且会在下滑时隐藏，
 * 双吸顶会互相叠层/偏移打架；这里用「滚动高亮」替代吸顶。
 */

;(function () {
  'use strict'

  var nav = document.querySelector('.dd-gdur-nav')
  var steps = nav ? nav.querySelectorAll('a[data-dd-gdur-step]') : []

  /* ------------------------------------------------------------------------
     平滑滚动（点击步骤或 hero 的「Explore by Duration」按钮）
     ------------------------------------------------------------------------ */
  var scrollLinks = document.querySelectorAll('a[data-dd-gdur-step], a[data-dd-gdur-scroll]')
  for (var i = 0; i < scrollLinks.length; i++) {
    scrollLinks[i].addEventListener('click', function (e) {
      var href = this.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      var target = document.getElementById(href.slice(1))
      if (!target) return
      e.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if (history.replaceState) history.replaceState(null, '', href)
    })
  }

  if (!nav || !steps.length) return

  /* ------------------------------------------------------------------------
     滚动高亮（scrollspy）
     ------------------------------------------------------------------------ */
  function setActive(id) {
    for (var i = 0; i < steps.length; i++) {
      var isActive = steps[i].getAttribute('href') === '#' + id
      steps[i].classList.toggle('is-active', isActive)
      if (isActive) steps[i].setAttribute('aria-current', 'true')
      else steps[i].removeAttribute('aria-current')
    }
  }

  var groups = document.querySelectorAll('.dd-gdur-group[id]')
  if (!groups.length) return

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) setActive(entries[i].target.id)
        }
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    )

    for (var j = 0; j < groups.length; j++) observer.observe(groups[j])
  }
})()
